<template>
  <div class="c-amap">
    <div class="c-amap-container" ref="mapContainer"></div>
    <!-- <div class="search-wrap">
      <div>请输入关键字:</div>
      <input id="tipinput" />
    </div> -->
    <slot></slot>
  </div>
</template>

<script>
import MapLoader from "../libs/MapLoader";
import Emitter from "@/mixins/emitter";
import Mapmanager from "../libs/MapManager";

export default {
  mixins: [Emitter],
  props: {
    mapOptions: {
      //高德地图options
      type: Object,
      default() {
        return {
          center: [113.156673, 23.049808],
          zooms: [2, 20],
          zoom: 11,
          features: ["bg", "point", "building"],
        };
      },
    },
    showToolBar: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  data() {
    return {};
  },
  methods: {
    initMap() {
      let mapContainer = this.$refs.mapContainer;
      let mapOptions = this.mapOptions;
      let mapManager = new Mapmanager(mapContainer, mapOptions);
      // eslint-disable-next-line no-undef
      // let map = new AMap.Map(mapContainer, mapOptions);
      let map = mapManager.getMap();
      window.mapInstance = map;
      this.$amap = map;
      this.$mapManager = mapManager;

      this._map = map;
      this.broadcast("", "mapReady", map, mapManager); //通知子组件
      this.$emit("mapReady", map, mapManager);
      // this.addPOISearch();
      if (this.showToolBar) {
        this.addToolBar();
      }
    },

    addToolBar() {
      let self = this;
      // eslint-disable-next-line no-undef
      AMap.plugin(["AMap.ToolBar"], function () {
        if (self._map) {
          // eslint-disable-next-line no-undef
          let toolBar = new AMap.ToolBar({
            // 简易缩放模式，默认为 false
            liteStyle: true,
          });
          // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
          self._map.addControl(toolBar);
        }
      });
    },
    addPOISearch() {
      let autoOptions = {
        input: "tipinput",
      };
      let self = this;
      // eslint-disable-next-line no-undef
      AMap.plugin(["AMap.PlaceSearch", "AMap.AutoComplete"], function () {
        if (self._map) {
          // eslint-disable-next-line no-undef
          let auto = new AMap.AutoComplete(autoOptions);
          // eslint-disable-next-line no-undef
          let placeSearch = new AMap.PlaceSearch({
            map: self._map,
          });
          let select = (e) => {
            placeSearch.setCity(e.poi.adcode);
            placeSearch.search(e.poi.name);
          };
          auto.on("select", select);
        }
      });
    },
  },
  mounted() {
    MapLoader().then(() => {
      this.initMap();
    });
  },
  beforeDestroy() {
    if (this.$map) {
      window.mapInstance = this.$map.destroy();
      this.$root.$map = null;
    }
  },
};
</script>

<style scoped lang="scss">
.c-amap {
  position: relative;
  height: 100%;
  width: 100%;
  &-container {
    width: 100%;
    height: 100%;
  }
  .search-wrap {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}
</style>
